export function PieStatisticHandler (config) {
  let statistic = config?.statistic
  if (statistic.show) {
    if (statistic.title === '') { return }
    statistic.title.content = statistic?.title?.text ?? ''
    statistic.content.customHtml = function (container, view, datum, data) {
      let total = data.reduce((r, d) => {
        let t = r + d[config.angleField]
        return +t.toFixed(2)
      }, 0)
      return `${statistic.content.hbdw}${total}${statistic.content.dw}`
    }
  } else {
    if (statistic?.title) {
      statistic.title.content = ''
    }
    if (statistic?.content) {
      statistic.content.customHtml = function (container, view, datum, data) { return '' }
    }
  }
}

export function funnelConversionTagHandler (config) {
  let conversionTag = config.conversionTag
  conversionTag.formatter = function (val) {
    return conversionTag.formatterFn.replace(/{([a-zA-Z$]+)}|(\\n|\n)/g, ($1, $2, $3) => {
      if ($2) { return val[$2] }
      if ($3) { return '\r\n' }
    })
  }
}

export function checkG2ChartOpionHandler (config) {
  if (config.config.chartType === 'pie') {
    if (config.config.statistic) {
      PieStatisticHandler(config.config)
    }
  }
  if (config.config.chartType === 'funnel') {
    if (config.config?.conversionTag?.formatterFn) {
      funnelConversionTagHandler(config.config)
    }
  }
}
